import React from "react";
import OurGoalImg from "../../assests/img/image-dr.jpeg";

const OurGoal = () => {
  return (
    <div className="flex flex-col justify-between items-start mt-8 md:mt-10 lg:mt-12 px-4 md:px-6 lg:px-0">
      <div className="flex flex-col-reverse lg:flex-row justify-between items-center gap-6 w-full">
        <div className="w-full md:max-w-[90%] lg:max-w-[70%]">
          <div className="text-[28px] sm:text-[32px] md:text-[38px] lg:text-[44px] text-[#1A76D1] font-poppins font-[600] text-center md:text-left">
            Dr. Rajeshwari Angadi, Dentist
          </div>
          <div className="mt-3 md:mt-4 lg:mt-5 mb-6 md:mb-8 lg:mb-12 text-[15px] md:text-[16px] leading-relaxed">
            Dr. Rajeshwari Angadi has opened doors of Shellharbour Road Dentists
            since early 2025 after working in Dapto(Brighter Smiles Dapto
            Dental) for more than 10 years. Dr. Angadi being caring, considerate
            and gentle in her approach has treated many patients and families
            with highest level of satisfaction. Dr. Angadi carries a vast amount
            of experience in providing comprehensive dental services and updates
            herself with latest advancements and technology.
          </div>
        </div>
        <div className="mb-6 md:mb-8 lg:mb-0">
          <img
            src={OurGoalImg}
            alt="Dr. Rajeshwari Angadi"
            className="h-[12rem] sm:h-[14rem] md:h-[16rem] w-auto object-cover rounded-lg shadow-md"
          />
          {/*<div className="p-5">*/}
          {/*    <span className="mt-2 text-[18px] font-medium">Dr. Rajeshwari Angadi</span>*/}
          {/*</div>*/}
        </div>
      </div>
    </div>
  );
};

export default OurGoal;
